import { InjectionToken } from '@angular/core';

class GlobalProductUpdates {
  public enabled: boolean = true;
  public toggleEnabled(enabled: boolean): void {
    this.enabled = enabled;
  }
}

export const GlobalProductUpdatesState = new InjectionToken(
  'manages the global state of updates like tutorial dialog, feature tooltip etc.',
  {
    providedIn: 'root',
    factory: () => new GlobalProductUpdates(),
  },
);
